import { COMPROBANTE_LIQUIDACION_TYPES } from "../constants/comprobante-liquidacion.types";
import { ActionCL, ComprobanteLiquidacion, StateCL } from "../interfaces/comprobante-liquidacion.interface";

const initialState: ComprobanteLiquidacion = {
    view: 'Formularios',

    formCliente: {
        fecha: '',
        tipoDocumento: '36',
        noDocumento: '',
        nombre: '',
        departamento: '',
        municipio: '',
        direccion: '',
        email: '',
        chipsEmail: [],
        telefono: '',
        actividad: '',
        actividadDescripcion: '',
        departamentoDescripcion: '',
        municipioDescripcion: '',
        nrc: '',
        
        datosSucursal: [],
        datosDocumento: [],

        sucursal: '',
        serie: '',
        loadedSucursal: false,
    },

    formBusquedaDocumento: {
        fechaInicial: '',
        fechaFinal: '',
        tipoDocumento: '',
        noIdentificacion: '',
        tipoIdentificacion: '36',
        nombre: '',
    },

    errorsFormBusquedaDocumento: {
        fechaInicial: '',
        fechaFinal: '',
        tipoDocumento: '',
        noIdentificacion: '',
        tipoIdentificacion: '',
        nombre: '',
    },

    formDocumentoFisico: {
        tipoDTE: '',
        noDocumento: '',
        fechaEmision: '',
        gravadas: '0',
        noSujeto: '0',
        exentas: '0',
        montoIVA: '0',
    },

    errorsDocumentoFisico: {
        tipoDTE: '',
        noDocumento: '',
        fechaEmision: '',
        gravadas: '',
        noSujeto: '',
        exentas: '',
        montoIVA: '',
    },

    clienteEncontrado: {},

    productoIndex: null,

    errorsCliente: {
        fecha: '',
        tipoDocumento: '',
        noDocumento: '',
        nombre: '',
        departamento: '',
        municipio: '',
        direccion: '',
        email: '',
        telefono: '',
        actividad: '',
        nrc: '',
    
        sucursal: '',
        serie:''
    },

    productos: [],

    modal_editar: false,
    modal_eliminar: false,
    modal_quitarTodo: false,
    modal_emitir: false,
    modal_emitido: false,
    modal_masOpciones: false,
    modal_enviarCorreo: false,
    modal_imprimir: false,
    modal_anular: false,
    modal_anulado: false,
    modal_clienteEncontrado: false,
    modal_buscarDocumentos: false,
    modal_editarDocumentoFisico: false,
    modal_agregarDocumentoFisico: false,

    response_QRcode: '',
    response_Emitir: null,

    calculosGenerales: {
        subtotal: '',
        descuento: '',
        total: ''
    },

    loader_asociarDocumentos: false,
    documentosEncontrados: [],
    documentosAsociados: [],
    mostrarDetalle: true,
    tableProductos: [],
    documentoFisicoEdit: '',
    formObservaciones: {
        referencia: '',
        observaciones: '',
        mostrarObservacionesPdf: true,
        incluirObservacionesCorreo: true,
    },
}

const comprobanteLiquidacionReducer = ( state: ComprobanteLiquidacion = initialState, action: ActionCL ) : StateCL => { 
    switch (action.type) {
        case COMPROBANTE_LIQUIDACION_TYPES.CL_SET_FORM_CLIENTE: return {...state, formCliente: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_HANDLE_ERRORS_CLIENTE: return {...state, errorsCliente: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_SET_VIEW: return {...state, view: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_SET_PRODUCTOS: return {...state, productos: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_SET_PRODUCTO_INDEX: return {...state, productoIndex: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_EDITAR_PRODUCTO: return {...state, modal_editar: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_ELIMINAR_PRODUCTO: return {...state, modal_eliminar: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_QUITAR_TODO: return {...state, modal_quitarTodo: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_EMITIR: return {...state, modal_emitir: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_EMITIDO: return {...state, modal_emitido: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_MAS_OPCIONES: return {...state, modal_masOpciones: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_ENVIAR_CORREO: return {...state, modal_enviarCorreo: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_ANULAR: return {...state, modal_anular: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_ANULADO: return {...state, modal_anulado: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_IMPRIMIR: return {...state, modal_imprimir: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_SET_CALCULOS_GENERALES: return {...state, calculosGenerales: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_SET_QR_CODE: return {...state, response_QRcode: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_SET_RESPONSE_EMITIR: return {...state, response_Emitir: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_SET_CLIENTE_ENCONTRADO: return {...state, clienteEncontrado: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_CLIENTE_ENCONTRADO: return {...state, modal_clienteEncontrado: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_SET_DOCUMENTOS_ENCONTRADOS: return{...state, documentosEncontrados: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_SET_DOCUMENTOS_ASOCIADOS: return{...state, documentosAsociados: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_SET_LOADER_DOCUMENTOS_ASOCIADOS: return{...state, loader_asociarDocumentos: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_SET_FORM_BUSQUEDA_DOCUMENTO: return{...state, formBusquedaDocumento: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_HANDLE_ERRORS_BUSQUEDA_DOCUMENTO: return{...state, errorsFormBusquedaDocumento: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_HANDLE_ACTIVE_MOSTRAR_DETALLE: return{...state, mostrarDetalle: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_MODAL_BUSQUEDA_DOCUMENTO: return{...state, modal_buscarDocumentos: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_SET_TABLE_PRODUCTOS: return{...state, tableProductos: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_SET_FORM_DOCUMENTO_FISICO: return{...state, formDocumentoFisico: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_HANDLE_ERRORS_DOCUMENTO_FISICO: return{...state, errorsDocumentoFisico: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_EDITAR_DOCUMENTO_FISICO: return{...state, modal_editarDocumentoFisico: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_ACTIVE_AGREGAR_DOCUMENTO_FISICO: return{...state, modal_agregarDocumentoFisico: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_SET_DOCUMENTO_FISICO_EDIT: return{...state, documentoFisicoEdit: action.payload}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_FORMOBSERVACIONES_HANDLE_CHANGE: return {...state, formObservaciones: {...state.formObservaciones, ...action.payload}}
        case COMPROBANTE_LIQUIDACION_TYPES.CL_RESTART_ALL: return {...initialState, productos: [], documentosAsociados: [], documentosEncontrados: []}
        default: return state;
    }
}

export default comprobanteLiquidacionReducer